export enum IChallengeTargetResultEnum {
  count = 'ChallengeTargetResult.count',
  userCount = 'OrgChallengeTargetResult.userCount',
  dayCount = 'OrgChallengeTargetResult.dayCount',
  successTotal = 'OrgChallengeTargetResult.successtotal',
  failTotal = 'OrgChallengeTargetResult.failtotal',
  accountId = 'ChallengeTargetResult.accountid',
  userId = 'ChallengeTargetResult.userid',
  createdBy = 'ChallengeTargetResult.createdby',
  createdAt = 'ChallengeTargetResult.createdat',
  updatedBy = 'ChallengeTargetResult.updatedby',
  updatedAt = 'ChallengeTargetResult.updatedat',
  challengeId = 'ChallengeTargetResult.challengeid',
  challengeTargetId = 'ChallengeTargetResult.challengetargetid',
  targetValue = 'ChallengeTargetResult.targetvalue',
  result = 'ChallengeTargetResult.result',
  localDate = 'ChallengeTargetResult.localdate',
  weekdayIndex = 'ChallengeTargetResult.weekdayindex',
}
